const Reflux = require('@muzzylane/reflux');
const isObject = require('lodash/isObject');

const ServerRequest = require('./request');
const ErrorConsts = require('../constants/error');
const ForgeError = require('../util/error');
const AssetUtil = require('../util/asset');

const BadgeActions = Reflux.createActions({
    getBadgeServices: { children: ['completed', 'failed'] },
    addBadgeService: { children: ['completed', 'failed'] },
    updateBadgeService: { children: ['completed', 'failed'] },
    getBadgeTemplates: { children: ['completed', 'failed'] },
    addBadgeTemplate: { children: ['completed', 'failed'] },
    updateBadgeTemplate: { children: ['completed', 'failed'] },
    removeBadgeTemplate: { children: ['completed', 'failed'] },
    getBadgeTemplateDetails: { children: ['completed', 'failed'] },
    getChannelBadgeTemplates: { children: ['completed', 'failed'] },
});

// Gets organization badge services
BadgeActions.getBadgeServices.listen(function(actionId,orgId) {
    ServerRequest.makeRequest(`/authoring/organization/${orgId}/badge_services`, 'GET')
        .then(res => this.completed(actionId, orgId, res))
        .catch(err => this.failed(actionId, orgId, err));
});

// requires admin. Add a badge service
BadgeActions.addBadgeService.listen(function(actionId, params) {
    let orgId = params.org_user_id;
    let validParams = {
        name: params.name,
        service_type: params.service_type,
        endpoints: {
            base_api: params.endpoints.base_api,
        },
        credentials: {
            organization_id: params.credentials.organization_id,
            token: params.credentials.token
        }
    };
    if (!orgId || !validParams.name || !validParams.service_type || !validParams.endpoints.base_api || !validParams.credentials.organization_id || !validParams.credentials.token) {
        this.failed(actionId, JSON.stringify(validParams), new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }
    
    ServerRequest.makeRequest(`/authoring/organization/${orgId}/badge_service`, 'POST', JSON.stringify(validParams))
        .then(res => this.completed(actionId, orgId, res))
        .catch(err => this.failed(actionId, orgId, err));
});

// Update a badge service
BadgeActions.updateBadgeService.listen(function(actionId, params) {
    let orgId = params.org_user_id;
    let validParams = {
        endpoints: {
            base_api: params.endpoints.base_api,
        },
        credentials: {
            organization_id: params.credentials.organization_id,
            token: params.credentials.token
        }
    };
    if (!validParams.endpoints.base_api || !validParams.credentials.organization_id || !validParams.credentials.token) {
        this.failed(actionId, JSON.stringify(validParams), new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }
    
    ServerRequest.makeRequest(`/authoring/organization/${orgId}/badge_service/${params.id}`, 'PUT', JSON.stringify(validParams))
        .then(res => this.completed(actionId, orgId, res))
        .catch(err => this.failed(actionId, orgId, err));
});


// requires admin. Gets all badge templates
BadgeActions.getBadgeTemplates.listen(function(actionId,orgId) {
    ServerRequest.makeRequest(`/authoring/organization/${orgId}/badge_templates`, 'GET')
        .then(res => this.completed(actionId, orgId, res))
        .catch(err => this.failed(actionId, orgId, err));
});

// requires admin. Add badge template
BadgeActions.addBadgeTemplate.listen(function(actionId,orgId,params) {
    let validParams = {
        service_id: params.service_id,
        third_party_badge_template_id: params.third_party_badge_template_id,
    }    
    if (!validParams.service_id || !validParams.third_party_badge_template_id) {
        this.failed(actionId, JSON.stringify(validParams), new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }
    
    ServerRequest.makeRequest(`/authoring/organization/${orgId}/badge_template`, 'POST',JSON.stringify(validParams))
        .then(res => this.completed(actionId, orgId, res))
        .catch(err => this.failed(actionId, orgId, err));
});


// requires admin. Update existing badge template (for img_src if badge service doesn't supply it) 
BadgeActions.updateBadgeTemplate.listen(function(actionId,orgId,params) {
    let validParams = {
        badge_template_hash: params.badge_template_hash,
        updates: params.updates,
    }    
    if (!validParams.badge_template_hash || !params.updates) {
        this.failed(actionId, JSON.stringify(validParams), new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }
    
    ServerRequest.makeRequest(`/authoring/organization/${orgId}/badge_template`, 'PUT',JSON.stringify(validParams))
        .then(res => this.completed(actionId, orgId, res))
        .catch(err => this.failed(actionId, orgId, err));
});

// Remove badge template
BadgeActions.removeBadgeTemplate.listen(function(actionId,orgId,badgeTemplateHash) {
    if (!orgId || !badgeTemplateHash) {
        this.failed(actionId, {orgId,badgeTemplateHash}, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }
    ServerRequest.makeRequest(`/authoring/organization/${orgId}/badge_template/${badgeTemplateHash}`, 'DELETE')
        .then(res => this.completed(actionId, orgId, res))
        .catch(err => this.failed(actionId, orgId, err));
});

BadgeActions.getBadgeTemplateDetails.listen(function(actionId,orgId,badgeTemplateHash) {
    if (!orgId || !badgeTemplateHash) {
        this.failed(actionId, {orgId,badgeTemplateHash}, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }
    ServerRequest.makeRequest(`/authoring/organization/${orgId}/badge_template_details/${badgeTemplateHash}`, 'GET')
        .then(res => this.completed(actionId, orgId, res))
        .catch(err => this.failed(actionId, orgId, err));
});


BadgeActions.getChannelBadgeTemplates.listen(function(actionId, params) {
    if (!params.channelId) {
        this.failed(actionId, params.channelId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }
    
    ServerRequest.makeRequest(`/authoring/channel/${params.channelId}/badge_templates`, 'GET')
        .then(res => this.completed(actionId, params.channelId, res))
        .catch(err => this.failed(actionId, params.channelId, err));
});

module.exports = BadgeActions;